import { withSvgIcon } from './withSvgIcon';

export const DiscountIcon = withSvgIcon(
  <>
    <path
      d="M10.2871 3.62338C10.4886 3.33565 10.8262 3.17471 11.1766 3.19944L17.4917 3.64504C17.8601 3.67104 18.1842 3.89796 18.3346 4.23525L20.9132 10.017C21.0563 10.3378 21.0205 10.7102 20.8191 10.9979L13.6054 21.3001C13.2886 21.7525 12.6651 21.8625 12.2126 21.5457L3.31899 15.3183C2.86659 15.0015 2.75664 14.378 3.07342 13.9256L10.2871 3.62338Z"
      stroke="currentColor"
      strokeWidth="currentWidth"
      strokeLinejoin="round"
    />
    <circle
      cx="14.7715"
      cy="8.4267"
      r="1.92857"
      transform="rotate(35 14.7715 8.4267)"
      fill="currentColor"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
